import * as React from "react";
import type { SVGProps } from "react";
const SvgTuvDuration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="-54.4 335.6 78.1 131.3"
    {...props}
  >
    <path
      d="m15.6 378.2.1-.1c5.3-7.5 8-16.3 8-25.4V339l-4.9-1.2c-.9-.2-9.4-2.2-17.5-2.2-8.3 0-16.6 2-17 2.1-.3.1-7.9 2-15.5 2s-15.2-1.9-15.5-1.9l-7.6-1.9v9.6l1 .4c.1 0 5 1.8 10.9 2.8 3.2.5 7.1.9 11.1.9 8.7 0 17-2 17.9-2.2.1 0 7.5-1.8 14.6-1.8 4.5 0 9.5.8 12.5 1.4v5.7c0 7.1-2.1 13.8-6.2 19.6l-14.4 19.1c-.1.2-.3.4-.4.5-4.2 6.1-4.2 14.3 0 20.4.1.2.3.4.4.5l14.4 19.1c4 5.8 6.2 12.6 6.2 19.6v5.4H8.2l-14.7-17.3c-4.3-6.2-13.5-6.2-17.8 0L-39 456.9h-5.5v-5.4c0-7.1 2.1-13.8 6.2-19.6l14.6-19.3.1-.1c4.4-6.2 4.4-14.5 0-20.7l-14.7-19.5c-2.9-4.2-4.8-8.8-5.7-13.7-4.2-.7-8-1.8-10.3-2.5.6 7.9 3.3 15.4 7.9 22l14.7 19.5c1.9 2.8 1.9 6.4 0 9.2l-14.6 19.3-.1.1c-5.3 7.5-8 16.3-8 25.4v15.3h78v-15.4c0-9.1-2.8-17.9-8-25.4L1 406.7l-.1-.2c-1.8-2.7-1.8-6.2 0-9l14.7-19.3z"
      style={{
        fill: "#0071b9",
      }}
    />
  </svg>
);
export default SvgTuvDuration;
